import { Component, Input, Output, EventEmitter, OnChanges, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

const AREA_CODES = ['mm2', 'cm2', 'm2', 'mm²', 'cm²', 'm²'];

@Component({
  selector: 'app-area-quantity-input',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './area-quantity-input.component.html',
  styleUrl: './area-quantity-input.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class AreaQuantityInputComponent implements OnChanges {
  @Input() uomCode: string = '';
  @Input() value: number = 0;
  @Input() cssClass: string = '';
  @Output() valueChange = new EventEmitter<number>();

  mode: 'direct' | 'calculate' = 'direct';
  lengthMm: number = 0;
  widthMm: number = 0;

  get isAreaUom(): boolean {
    return AREA_CODES.includes((this.uomCode || '').toLowerCase());
  }

  get displayUomCode(): string {
    return (this.uomCode || '').replace(/2$/, '²');
  }

  ngOnChanges(): void {
    if (!this.isAreaUom) {
      this.mode = 'direct';
    }
  }

  onDirectChange(): void {
    this.valueChange.emit(this.value);
  }

  onDimensionsChange(): void {
    const rawMm2 = this.lengthMm * this.widthMm;
    const code = (this.uomCode || '').toLowerCase();
    if (code === 'cm2' || code === 'cm²') {
      this.value = rawMm2 / 100;
    } else if (code === 'm2' || code === 'm²') {
      this.value = rawMm2 / 1_000_000;
    } else {
      this.value = rawMm2;
    }
    this.valueChange.emit(this.value);
  }

  setMode(m: 'direct' | 'calculate'): void {
    this.mode = m;
    this.lengthMm = 0;
    this.widthMm = 0;
    if (m === 'calculate') {
      this.value = 0;
      this.valueChange.emit(0);
    }
  }
}
